import React from 'react'
import UniqueOfferings from './UniqueOfferings'
import FinancialCrimeData from './FinancialCrimeData'
import WhyBestinMarket from './WhyBestinMarket'
import WhereQberaaCanHelp from './WhereQberaaCanHelp'
import QberaaMain from './QberaaMain'
import { motion } from 'framer-motion';

function Home() {
    return (
        <>
            <motion.div className="containerHome"
                initial={{ opacity: 0.5 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0.5 }}
                transition={{ duration: 0.5 }}
            >
                <QberaaMain></QberaaMain>
                <UniqueOfferings></UniqueOfferings>
                <WhyBestinMarket></WhyBestinMarket>
                <FinancialCrimeData></FinancialCrimeData>
                <WhereQberaaCanHelp></WhereQberaaCanHelp>
            </motion.div>
        </>
    )
}

export default Home

